import { BehaviorParameters } from 'rangeConfig/@types';
import { ErrorMessages, ProductType } from '@inter-ikea-storageone/range';
import { changeToSoftClosingFunctionAndAddHandles } from 'rangeConfig/besta/utils/doorClosingFunction';
import { ComponentIds } from '@inter-ikea-core/core';
import { getAllowedHandleTypes } from 'rangeConfig/shared/utils/frontLayouts';
import { BestaOpeningFunctionComponent } from '@inter-ikea-storageone/range-besta';
import { showPushToOpenSheet } from 'rangeConfig/besta/features/PushToOpen/PushToOpenFeature';
import { showFrontsOpeningFunctionSheet } from 'rangeConfig/besta/features/FrontsOpeningFunction/FrontsOpeningFunctionFeature';
import {
  hideNoDoorsInSceneErrorMessage,
  hideNoFramesInSceneErrorMessage
} from 'rangeConfig/shared/rules/hideMenuRules';

const autoFillHandlesBehavior = ({
  coreApi,
  dispatch,
  props,
  rootState: {
    products: { inMarket: products }
  }
}: BehaviorParameters) => {
  const placementAttemptErrorMessage = !hideNoFramesInSceneErrorMessage(coreApi)
    ? ErrorMessages.NoFramesInScene
    : hideNoDoorsInSceneErrorMessage(coreApi)
    ? ErrorMessages.NoDoorsInScene
    : null;
  if (placementAttemptErrorMessage) {
    coreApi.emit.onPlacementAttempt(placementAttemptErrorMessage);
  }

  const frontsInScene = coreApi.entities.getByComponents([
    ComponentIds.DOOR_COMPONENT_ID,
    ComponentIds.DRAWER_COMPONENT_ID
  ]);

  const frontsWithoutIncludedHandlesInScene = frontsInScene.filter(
    front => getAllowedHandleTypes(front).length > 0
  );

  if (frontsWithoutIncludedHandlesInScene.length === 0) {
    // Trigger an add we know will fail to get the placementAttempt and provide user feedback
    coreApi.products.add(props.coreProductId);

    return;
  }

  const fronts = coreApi.entities.getByComponent(BestaOpeningFunctionComponent.id);
  const isPushToOpenSelected = fronts.every(
    front =>
      front.getComponent<BestaOpeningFunctionComponent>(BestaOpeningFunctionComponent.id)
        ?.openingFunction === ProductType.BESTA_PUSH_OPEN
  );

  const handlesInScene = coreApi.entities.getByComponent(ComponentIds.HANDLE_COMPONENT_ID);

  if (isPushToOpenSelected) {
    dispatch(showPushToOpenSheet(props.coreProductId));
    return;
  }

  const isHandleMismatch =
    handlesInScene.length !== 0 &&
    frontsWithoutIncludedHandlesInScene.length > handlesInScene.length;

  if (isHandleMismatch) {
    dispatch(showFrontsOpeningFunctionSheet(props.coreProductId));
  } else {
    changeToSoftClosingFunctionAndAddHandles(props.coreProductId, coreApi, products);
  }
};

export default autoFillHandlesBehavior;
